import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { CommittedRowSchema } from '../../shared/bulk-commit.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Initialize System Input Schema
 * Wizard row shape: the Systemverantwortliche:r is identified by email
 * (resolved to a user server-side), matching the Excel template.
 */ export const InitializeSystemInputSchema = z.strictObject({
    name: z.string().min(1),
    description: z.string().optional(),
    category: z.string().optional(),
    url: z.string().optional(),
    licenceSeats: z.number().int().nonnegative().optional(),
    ownerEmail: z.email()
});
/**
 * Update System Input Schema
 * In-place edit of a wizard-seeded system, matched by `_id`
 * (ADR 0011, second amendment — extended to the optional steps)
 */ export const UpdateSystemInputSchema = InitializeSystemInputSchema.safeExtend({
    _id: ObjectIdSchema
});
/**
 * Initialize Add Systems Request Schema
 * POST /api/v2/initialize/systems
 * Re-enterable: rows whose name already exists are skipped.
 */ export const InitializeAddSystemsRequestSchema = z.object({
    systems: z.array(InitializeSystemInputSchema),
    // In-place edits of already-seeded rows, matched by `_id` (ADR 0011,
    // second amendment — extended to the optional steps).
    updates: z.array(UpdateSystemInputSchema).optional(),
    // Surgical deletion of already-seeded rows by `_id` (ADR 0011, third
    // amendment — extended to the optional steps).
    removals: z.array(ObjectIdSchema).optional()
}).refine((v)=>v.systems.length > 0 || !!v.updates?.length || !!v.removals?.length, {
    message: 'at least one of systems, updates or removals is required',
    path: [
        'systems'
    ]
}).refine((v)=>!v.updates?.some((update)=>v.removals?.includes(update._id)), {
    message: 'an id cannot appear in both updates and removals',
    path: [
        'removals'
    ]
});
/**
 * Initialize Add Systems Response Schema
 * One result per request `systems` row, in request order; skipped rows carry
 * the existing system's id so the wizard can edit it in place.
 */ export const InitializeAddSystemsResponseSchema = z.object({
    systems: z.array(CommittedRowSchema)
});
export const InitializeAddSystemsErrorSchema = BaseErrorSchema;

//# sourceMappingURL=initialize-add-systems.schema.js.map